import ChangePasswordFields from "../components/common/header/changePassword/ChangePasswordFields"
import {
	GET_NOTIFICATION_SUCCESS,
	GET_NOTIFICATION_FAILED,
	UPDATE_NOTIFICATION_SUCCESS,
	UPDATE_NOTIFICATION_FAILED,
	CHANGE_CASE_MODE_REQUEST_FAILED,
	CHANGE_PASSWORD,
	CHANGE_PASSWORD_SUCCESS,
	CHANGE_PASSWORD_FAIL,
	CHANGE_PASSWORD_RESET,
} from "../types"

const initialState = {
	notification: [],
	loading: false,
	passwordChanged: null,
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_NOTIFICATION_SUCCESS:
			return {
				...state,
				notification: action.payload,
			}
		case GET_NOTIFICATION_FAILED:
			return {
				...state,
				notification: [],
			}
		case UPDATE_NOTIFICATION_SUCCESS:
			return {
				...state,
				notification: action.payload,
			}
		case UPDATE_NOTIFICATION_FAILED:
			return {
				...state,
				notification: [],
			}
		case CHANGE_PASSWORD:
			return {
				...state,
				loading: true,
			}
		case CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				passwordChanged: true,
				loading: false,
			}
		case CHANGE_PASSWORD_FAIL:
			return {
				...state,
				passwordChanged: false,
				loading: false,
			}
		case CHANGE_PASSWORD_RESET:
			return { ...state }

		default:
			return state
	}
}
